<script>
import moment from "moment";
import axios from '@/utils/axios';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import { viewPDF } from '@/utils/sales-order';
import DateRangePicker from "daterangepicker";
import { productionUsers } from '@/utils/user';
import StatusBadge from '@/components/common/sales-order-status-badge.vue';
import { Modal } from 'bootstrap';

export default {
  inject: ['setLoading'],
  components: {
   StatusBadge 
  },
  data() {
    return {
      tableColumns: [
  { key: 'so_number', label: 'SO No' },
  { key: 'status', label: 'Status' },
  { key: 'client_name', label: 'Client Name' },
  { key: 'client_phone', label: 'Client Phone' },
  { key: 'created_by', label: 'Created By' },
  { key: 'production_user', label: 'Production User' },
  { key: 'date', label: 'Date' },
  { key: 'actions', label: 'Actions' },
],
      title: "Finance & Accounts",
      text: "Finance & Accounts",
      data: [],
      users: [],
      app_currency: '',
      status_data: [],
      pagination: {
       current_page: 1,
       per_page: 25,
       last_page: 1,
       total: 0,
       links: []
      },
      filter: {
       status: '', 
       to_date: '',
       from_date: '',
       search_keyword: '',
       user_id: '',
      },
      loading: false,
      module_url: 'sales-orders',
    };
  },

  computed: {
   text1(){
    return `Sales Orders (${this.pagination.total})`;
   }, 
  //  serialNo(){
  //   return (this.pagination.current_page - 1) * this.pagination.per_page;
  //  } 
  },

  async mounted(){
   this.getUsers(); 
   this.app_currency = await this.$appCurrency();
   this.filter.status = this.$route.query.status || '';
   this.loadAll();

   const start = moment().subtract(29, "days");
   const end = moment();

    new DateRangePicker(
      this.$refs.dateRangeInput,
      {
        startDate: start,
        endDate: end,
        locale: {
         format: "DD/MM/YYYY",
         separator: " - "
        },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        }
      },
      (start, end) => {
        this.setDateRange(start, end);
      },
      this.booking_range
    );
    // Initialize filter date range as soon as picker mounts
    //this.setDateRange(start, end);
    
  }, 

  methods: {

    async generateTaxInvoice(row) {
  try {
    this.setLoading(true);
    const response = await axios.get(`/${this.module_url}/${row.public_token}`);
    const salesOrder = response.data.data;

    // Invoice modal ko pre-fill karo
    await this.$refs.invoiceModal.createFromSalesOrder(salesOrder);

    // Invoice modal open karo
    const modalEl = document.getElementById("invoice_modal");
    let modal = Modal.getInstance(modalEl);
    if (!modal) { modal = new Modal(modalEl); }
    modal.show();
  } catch(error) {
    this.$swalToast(error.message, 'error');
  } finally {
    this.setLoading(false);
  }
},

    async loadAll(){
     this.salesOrders();
     this.statusData(); 
    },

    async selectStatus(status){
     this.filter.status = status;
     await this.salesOrders();
    },

    async statusData(){
     try{
      const response = await axios.get(`/sales-orders/status-wise/data`);
      this.status_data = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }
    },

    async getUsers(){
     try{
      const response = await productionUsers();
      this.users = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }
    },

    booking_range(start, end) {
     return start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
    },

    setDateRange(start, end) {
     this.filter.from_date = start.format("YYYY-MM-DD");
     this.filter.to_date = end.format("YYYY-MM-DD");
    },

    async approve(id){
     if(!this.users.length){
      await this.getUsers();
     }
     const { value: formValues } = await this.$swal.fire({
      title: 'Assign to Production',
      html: `
       <div class="mb-3">
        <label class="form-label fw-semibold">Select Production User</label>
        <select id="productionUser" class="form-select">
          <option value="">Choose Production User</option>
          ${this.users.map(user => 
            `<option value="${user.id}">${user.name}</option>`
          ).join('')}
        </select>
       </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Assign & Approve',
      cancelButtonText: 'Cancel',
      preConfirm: () => {
       const productionUserId = document.getElementById('productionUser').value;
       if(!productionUserId){
        this.$swal.showValidationMessage('Please select a production user');
        return false;
       }
      
       return {
        production_user_id: productionUserId,
        id: id
       }
      }
    });

    if(formValues){
     await this.saveApprove(formValues);
    }
   },

   async saveApprove(formValues) {
    this.setLoading(true);
    try{
     const response = await axios.patch(`/${this.module_url}/${formValues.id}/assign-approve`, {
      user_id: formValues.production_user_id
     });
    
     this.$swalToast('Sales Order approved and assigned to production!', 'success');
     // Refresh current page data
     await this.loadAll();
    }catch(error){
     this.$swalToast(error.response?.data?.message || 'Failed to approve', 'error');
    }finally{
     this.setLoading(false);
    }
   },

   async reject(id) {
    const { value: formValues } = await this.$swal.fire({
     title: 'Reject Sales Order',
     html: `
      <div class="mb-3">
        <label class="form-label fw-semibold">Rejection Remark <span class="text-danger">*</span></label>
        <textarea id="rejectRemark" class="form-control" rows="3" placeholder="Enter reason for rejection..." required></textarea>
      </div>
     `,
     showCancelButton: true,
     confirmButtonText: 'Reject Sales Order',
     cancelButtonText: 'Cancel',
     confirmButtonColor: '#dc3545',
     preConfirm: () => {
      const remark = document.getElementById('rejectRemark').value.trim();
      
      if(!remark){
       this.$swal.showValidationMessage('Please enter a rejection remark');
       return false;
      }
      
      if(remark.length < 10){
       this.$swal.showValidationMessage('Remark must be at least 10 characters long');
       return false;
      }
      
      return {
       remark: remark,
       id: id
      }
     }
    });
    if(formValues){
     await this.saveReject(formValues);
    }
   },

   async saveReject(formValues) {
    this.setLoading(true);
     try{
      const response = await axios.patch(`/${this.module_url}/${formValues.id}/reject`, {
       remark: formValues.remark
      });
    
      this.$swalToast('Sales Order rejected successfully!', 'success');
      // Refresh current page data
      await this.loadAll();
     }catch(error){
      this.$swalToast(error.response?.data?.message || 'Failed to reject sales order', 'error');
     }finally{
      this.setLoading(false);
     }
   },
  
   async updateStatus(row) {
    const statuses = [
     { value: 'dispatched', label: 'Dispatched' },
     { value: 'completed', label: 'Completed' },
    ];

    const { value: formValues } = await this.$swal.fire({
     title: 'Update Status',
     html: `
      <div class="mb-3">
       <label class="form-label fw-semibold">Status</label>
       <select id="statusSelect" class="form-select">
        ${statuses.map(status => 
         `<option value="${status.value}" ${row.status === status.value ? 'selected' : ''}>
          ${status.label}
         </option>`
        ).join('')}
       </select>
      </div>
      <div class="mb-3">
       <label class="form-label fw-semibold">Tracking/LR Number</label>
       <input id="trackingNo" class="form-control" placeholder="Enter Tracking/LR number" value="${row.tracking_number || ''}" />
      </div>
      `,
     showCancelButton: true,
     confirmButtonText: 'Update',
     cancelButtonText: 'Cancel',
     preConfirm: () => {
      const trackingNo = document.getElementById('trackingNo').value.trim();
      if(!trackingNo){
       this.$swal.showValidationMessage('Please enter tracking/LR number');
       return false;
      }
  
      return {
       status: document.getElementById('statusSelect').value,
       tracking_number: trackingNo,
       id: row.id
      }
     }
    });

   if(formValues){
    await this.saveStatusUpdate(formValues, row);
   }
  },

  async saveStatusUpdate(formValues, row) {
   this.setLoading(true);
    try{
     // Status update
     await axios.patch(`/${this.module_url}/${formValues.id}/status/${formValues.status}`);
    
     if(formValues.tracking_number){
      await axios.patch(`/${this.module_url}/${formValues.id}/tracking`, {
        tracking_number: formValues.tracking_number
      });
     }

     this.$swalToast('Status updated successfully!', 'success');
     await this.loadAll();
    }catch(error){
     this.$swalToast(error.response?.data?.message || 'Failed to update status', 'error');
    }finally{
     this.setLoading(false);
    }
   },

   async updateTracking(row) {
    const { value: formValues } = await this.$swal.fire({
     title: 'Update Tracking',
     html: `
      <div class="mb-3">
        <label class="form-label fw-semibold">Tracking/LR Number</label>
        <input id="trackingNo" class="form-control" placeholder="Enter Tracking/LR number" value="${row.tracking_number || ''}" />
      </div>
     `,
     showCancelButton: true,
     confirmButtonText: 'Update Tracking',
     cancelButtonText: 'Cancel',
     preConfirm: () => {
      const trackingNo = document.getElementById('trackingNo').value.trim();
            
      if(!trackingNo){
       this.$swal.showValidationMessage('Please enter tracking number');
       return false;
      }
      
      return {
       tracking_number: trackingNo,
       id: row.id
      };
     }
    });

    if(formValues){
     await this.saveTrackingUpdate(formValues, row);
    }
   },

   async saveTrackingUpdate(formValues, row) {
    this.setLoading(true);
     try{
      const response = await axios.patch(`/${this.module_url}/${formValues.id}/tracking`, {
       tracking_number: formValues.tracking_number 
      });
      this.$swalToast('Tracking updated successfully!', 'success');
      // Refresh current page data
      await this.loadAll();
     }catch(error){
      if(error.type === 'validation'){
       this.errors = error.errors;
      }else{
       this.$swalToast(error.response?.data?.message || 'Failed to update tracking', 'error'); 
      }
     }finally{
      this.setLoading(false);
     }
   },

    async salesOrders(page = 1) {
     this.setLoading(true);
     try{
      const params = {
 page,
 status: this.filter.status,
 to_date: this.filter.to_date,
 from_date: this.filter.from_date,
 per_page: this.pagination.per_page,
 search_keyword: this.filter.search_keyword.trim() || ''
};
if (this.filter.user_id) params.user_id = this.filter.user_id;
      const query_string = new URLSearchParams(params).toString();
      const response = await axios.get(`/${this.module_url}?${query_string}`);
      this.data = response.data.data.data;
      this.pagination = {
        current_page: response.data.data.current_page,
        per_page: response.data.data.per_page,
        last_page: response.data.data.last_page,
        total: response.data.data.total,
        links: response.data.data.links
      };
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

   async salesOrderPDF(id){
    try{
     const response = await viewPDF(id);
     const file = new Blob([response.data], { type: 'application/pdf' });
     const fileURL = URL.createObjectURL(file);
     window.open(fileURL, '_blank');
    }catch(error){
     this.$swalToast("Failed to open PDF", 'error');
     console.error(error);
    }
   }, 

  //  changePage(url){
  //   if (!url) return;
  //   const page = new URL(url).searchParams.get("page");
  //   this.salesOrders(page);
  //  },

   clearFilter(){
 this.filter.status = '';
 this.filter.to_date = '';
 this.filter.from_date = '';
 this.filter.search_keyword = '';
 this.filter.user_id = '';
 this.salesOrders();
},

   async approveAfterSave(id) {
    await this.approve(id);
   },

   async rejectAfterSave(id) {
    await this.reject(id);
   },

   async openUpdateStatusFromQC(id) {
    // Find the row by id from current data to pass to updateStatus
    const row = this.data.find(r => r.id === id);
    if(row){
     await this.updateStatus(row);
    }
   },
    
  },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
  <div class="content">
    <!-- Breadcrumb -->
    <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <breadcrumb :title="title" :text="text" :text1="text1" />
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
        
        <!-- <div class="me-2 mb-2" v-if="pagination.total">
        <div class="dropdown">
        <a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown"><i class="ti ti-file-export me-1"></i>Export
        </a>
        <ul class="dropdown-menu dropdown-menu-end p-3">
        <li><a href="javascript:void(0);" class="dropdown-item rounded-1" @click="exportFile"><i class="ti ti-file-type-xls me-1"></i>Export as Excel</a>
        </li>
        </ul>
        </div>
        </div> -->
        

        <div class="mb-2" v-if="auth?.role?.is_sales_order_approver">
          <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#sales_order_modal" class="btn btn-primary d-flex align-items-center" @click="$refs.salesOrderModal.salesOrder();">
            <i class="ti ti-circle-plus me-2"></i>Add Sales Order
          </a>
        </div>
       
      </div>
    </div>
    <!-- /Breadcrumb -->

    <div class="row">

   <div class="col-md-3 cursor-pointer" v-for="(row, index) in status_data" :key="index" @click="selectStatus(row.status);">
    <div class="card flex-fill">
    <div class="card-body">
    <div class="d-flex align-items-center overflow-hidden mb-2">
    <div>
      <p class="fs-12 fw-normal mb-1 text-truncate">{{row.status}}</p>
      <!--<h5>{{app_currency.code}} {{row.amount}}</h5>-->
      <h5>Total: {{row.count}}</h5>
    </div>
    </div>
    <div class="attendance-report-bar mb-2">
    <div class="progress" role="progressbar" aria-label="Success example" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style="height: 5px;">
      <div :class="`progress-bar ${row.bg_color}`" :style="`width: ${row.percentage}%;`"></div>
    </div>
    </div>
    <div>
    <!-- <p class="fs-12 fw-normal d-flex align-items-center text-truncate"><span class="text-muted fs-12 d-flex align-items-center me-1">Total: {{row.count}}</span></p> -->
    </div>
    </div>
    </div>
   </div> 

  </div>


    <div class="card">
    <div class="card-header d-flex align-items-center justify-content-center flex-wrap row-gap-3">
    <!-- <h5>Payments List</h5> -->
    
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
    
    <div class="me-1" v-if="filter.search_keyword || filter.from_date || filter.to_date || filter.status || filter.user_id">
     <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
    </div>  

    <div class="me-3">
     <div class="input-icon-end position-relative">
      <input type="text" class="form-control date-range bookingrange" ref="dateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy">
      <span class="input-icon-addon"><i class="ti ti-chevron-down"></i></span>
     </div>
    </div>

    <div class="me-3">
      <vue-select
        v-model="filter.status"
        :options="[
          { label: 'Draft', value: 'draft' },
          { label: 'Approved', value: 'approved' },
          { label: 'Processing', value: 'processing' },
          { label: 'Dispatched', value: 'dispatched' },
          { label: 'Completed', value: 'completed' },
          { label: 'Cancelled', value: 'cancelled' },
          { label: 'Rejected', value: 'rejected' },
        ]"
        label="label"
        :reduce="s => s.value"
        placeholder="Status"
        :clearable="true"
        @update:modelValue="salesOrders()"
        style="min-width: 180px;"
      ></vue-select>
    </div>

     <div class="me-3">
      <vue-select
          v-model="filter.user_id"
          :options="users"
          label="name"
          :reduce="u => u.id"
          placeholder="Production User"
          :clearable="true"
          @update:modelValue="salesOrders()"
          style="min-width: 180px;"
      ></vue-select>
  </div>

    <div class="me-3">
    <div class="input-icon-end position-relative">
     <input type="text" class="form-control" v-model="filter.search_keyword" placeholder="Search...."/>
    </div>
    </div>

    <div class="">
     <button type="button" class="btn btn-dark" @click="salesOrders()"><i class="ti ti-search"></i></button>
    </div>

    </div>
    
   </div>

<div class="card-body card-table-wrapper">
  <app-table
    :columns="tableColumns"
    :rows="data"
    :pagination="pagination"
    :loading="false"
    empty-text="No records found."
    empty-icon="ti ti-file-off"
    @page-change="salesOrders"
  >

    <!-- SO Number -->
    <template #so_number="{ row }">
      <a href="javascript:void(0);" class="fw-bold text-primary" data-bs-toggle="modal" data-bs-target="#sales_order_detail_modal" @click="$refs.salesOrderModal.salesOrderActivity(row);">{{ row.so_number }}</a>
    </template>

    <!-- Status -->
    <template #status="{ row }">
      <StatusBadge :status="row.status"></StatusBadge>
    </template>

    <!-- Client Name -->
    <template #client_name="{ row }">
      {{ row?.party?.name }}
    </template>

    <!-- Client Phone -->
    <template #client_phone="{ row }">
      {{ row?.party?.mobile }}
    </template>

    <!-- Created By -->
    <template #created_by="{ row }">
      <img v-if="row?.created_by?.image" :src="row?.created_by?.image_url" width="22" class="rounded-circle" />
      <i v-else class="ti ti-user-circle fs-18 text-muted"></i>
      {{ row?.created_by?.name }}
    </template>

    <!-- Production User -->
    <template #production_user="{ row }">
      <template v-if="row?.user">
        <img v-if="row?.user?.image" :src="row?.user?.image_url" width="22" class="rounded-circle" />
            <i v-else class="ti ti-user-circle fs-18 text-muted"></i>
            {{ row?.user?.name }}
      </template>
      <span v-else class="text-muted">—</span>
    </template>

    <!-- Date -->
    <template #date="{ row }">
      {{ $formatDate(row.created_at, 'DD-MM-YYYY') }}
    </template>

    <!-- Actions -->
    <template #actions="{ row }">
      <div class="dropdown">
        <button class="btn btn-icon btn-sm rounded-circle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
          <i class="ti ti-dots-vertical"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-end p-3">
          <li v-if="auth?.role?.is_sales_order_approver && row.status !== 'dispatched' && row.status !== 'completed'">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#sales_order_modal" @click="$refs.salesOrderModal.salesOrder(row?.public_token)"><i class="ti ti-edit me-1"></i>Edit</a>
          </li>
          <li>
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="salesOrderPDF(row.id)"><i class="ti ti-file-type-pdf me-1"></i>View PDF</a>
          </li>
          <li v-if="auth?.role?.is_sales_order_production">
            <router-link class="dropdown-item rounded-1" :to="{ name: 'packaging-list', params: { public_token: row.public_token } }" target="_blank">
              <i class="ti ti-package me-1"></i>Print Packaging List
            </router-link>
          </li>
          <li v-if="auth?.role?.is_sales_order_production && !row.invoice_id">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="generateTaxInvoice(row)"><i class="ti ti-file-invoice me-1"></i>Generate Tax Invoice</a>
          </li>
          <li v-if="auth?.role?.is_sales_order_production">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#sales_order_qc_status_modal" @click="$refs.salesOrderModal.qcStatus(row.id, row.so_number, true, row.delivery_image)"><i class="ti ti-truck me-1"></i>Update QC Status</a>
          </li>
          <li v-if="auth?.role?.is_sales_order_production">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="updateStatus(row)"><i class="ti ti-progress me-1"></i>Update Status</a>
          </li>
          <li>
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#sales_order_qc_status_modal" @click="$refs.salesOrderModal.qcStatus(row?.id, row?.so_number, false, row?.delivery_image)"><i class="ti ti-file-type-pdf me-1"></i>View QC Status</a>
          </li>
          <li v-if="auth?.type === 'ADMIN'">
            <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#sales_order_delete_modal" @click="$refs.salesOrderModal.salesOrder(row.public_token)"><i class="ti ti-trash me-1"></i>Delete</a>
          </li>
        </ul>
      </div>
    </template>

  </app-table>
</div>
</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

<sales-order-modal
  ref="salesOrderModal"
  @updated="loadAll"
  @approve-after-save="approveAfterSave"
  @reject-after-save="rejectAfterSave"
  @open-update-status="openUpdateStatusFromQC">
</sales-order-modal>
<invoice-modal ref="invoiceModal" @updated="loadAll"></invoice-modal>

</template>

<style scoped>
.table-responsive {
  overflow-y: auto;
}
</style>